module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("61Oco"))).then(() => parcelRequire('hEqeo'));